import { render } from "./TemplateButton.vue?vue&type=template&id=b6668fea"
import script from "./TemplateButton.vue?vue&type=script&lang=js"
export * from "./TemplateButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__